import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconArrowTriangleBottom"><Path d="M4.07918 5.08541C3.96293 4.85292 3.97536 4.57681 4.11201 4.3557C4.24867 4.13459 4.49007 4 4.75 4H19.25C19.5099 4 19.7513 4.13459 19.888 4.3557C20.0246 4.57681 20.0371 4.85292 19.9208 5.08541L12.6708 19.5854C12.5438 19.8395 12.2841 20 12 20C11.7159 20 11.4562 19.8395 11.3292 19.5854L4.07918 5.08541Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleBottom;
